module.exports = __webpack_public_path__ + "img/contact-support-icon.svg";